import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="messages-container"
// Auto-scrolls to bottom when new messages are added
export default class extends Controller {
  connect() {
    // Scroll to bottom on initial load
    this.scrollToBottom()

    // Watch for new messages being added
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if any added node is a message element
          const hasNewMessage = Array.from(mutation.addedNodes).some(
            node => node.nodeType === Node.ELEMENT_NODE
          )
          if (hasNewMessage) {
            this.scrollToBottom()
          }
        }
      })
    })

    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  scrollToBottom() {
    // Use requestAnimationFrame to ensure DOM has updated
    requestAnimationFrame(() => {
      this.element.scrollTop = this.element.scrollHeight
    })
  }
}
